const IRDetector = ({ children }) => {
  const shouldRender = !window.location.hostname.includes(process.env.REACT_APP_SUBDOMAIN); // wartość z .env
  return shouldRender ? children : null;
};

export default IRDetector;